import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'real',
})
export class RealPipe implements PipeTransform {
  transform(
    value: number | null,
    currencySign: string = 'R$ ',
    decimalLength: number = 2,
    chunkDelimiter: string = '.',
    decimalDelimiter: string = ',',
    chunkLength: number = 3
  ): string {
    if (value == null) {
      value = 0;
    }

    const result =
      '\\d(?=(\\d{' +
      chunkLength +
      '})+' +
      (decimalLength > 0 ? '\\D' : '$') +
      ')';
    // eslint-disable-next-line no-bitwise
    const num = value.toFixed(Math.max(0, ~~decimalLength));

    return (
      currencySign +
      (decimalDelimiter ? num.replace('.', decimalDelimiter) : num).replace(
        new RegExp(result, 'g'),
        '$&' + chunkDelimiter
      )
    );
  }
}
